/**
 * Renderiza la información de los equipos derecho/izquierdo en la tarjeta de evento.
*/
export default function TeamBlock({ image, name, position, sport}) {

  const imaValid = String(image).length > 3 || String(image).length === 0;
  const flagClass = `bandera-list bandera-${!imaValid ? image : "list-vacia"}`;

  return (
    <div className={`teamlist teamlist-${position}`}>
      {sport === 'TNS' ? <div className={flagClass}></div> : <img src={image} alt={name || 'Equipo'} loading="lazy" />}
      <span className="teamlist-name">{name}</span>
    </div>
  );
}